export type ChatHomeTile = {
  id: number;
  title: string;
  description: string;
  question: string;
  sorting: number;
  country: string;
  product: string;
  culture: string;
  updatedUtc: string;
};

export type ChatHomeTilesState = {
  tiles: ChatHomeTile[];
  version: string;
};

export function parseChatHomeTiles(json: string): ChatHomeTilesState {
  try {
    const value = JSON.parse(json) as unknown;
    if (!isRecord(value)) return emptyState();

    return {
      tiles: Array.isArray(value.tiles)
        ? value.tiles.map(parseTile).filter(isChatHomeTile)
        : [],
      version: stringValue(value.version),
    };
  } catch {
    return emptyState();
  }
}

function parseTile(value: unknown): ChatHomeTile | null {
  if (!isRecord(value)) return null;

  const id = numberValue(value.id);
  const title = stringValue(value.title).trim();
  const description = stringValue(value.description).trim();
  const question = stringValue(value.question).trim();
  const country = stringValue(value.country).trim();
  const product = stringValue(value.product).trim();
  const culture = stringValue(value.culture).trim();

  if (
    id <= 0 ||
    !title ||
    !description ||
    !question ||
    !country ||
    !product ||
    !culture
  ) {
    return null;
  }

  return {
    id,
    title,
    description,
    question,
    sorting: numberValue(value.sorting),
    country,
    product,
    culture,
    updatedUtc: stringValue(value.updatedUtc),
  };
}

function emptyState(): ChatHomeTilesState {
  return { tiles: [], version: "" };
}

function isChatHomeTile(tile: ChatHomeTile | null): tile is ChatHomeTile {
  return tile !== null;
}

function numberValue(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

function stringValue(value: unknown): string {
  return typeof value === "string" ? value : "";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
